import { useTranslations } from '@vocab/react';
import { IconMoney, Text } from 'braid-design-system';

import {
  SalaryFrequency,
  type Salary as SalaryType,
} from '../../../types/profile.types';

import translations from './.vocab';

interface Props {
  salary: SalaryType;
}

export const Salary = ({ salary: { currency, expected, type } }: Props) => {
  const { t } = useTranslations(translations);

  const displaySalaryFromSalaryType: Record<SalaryFrequency, string> = {
    [SalaryFrequency.Hourly]: t('HOURLY_SALARY', {
      currency,
      expected,
    }),
    [SalaryFrequency.Monthly]: t('MONTHLY_SALARY', {
      currency,
      expected,
    }),
    [SalaryFrequency.Annual]: t('ANNUAL_SALARY', {
      currency,
      expected,
    }),
  };

  return (
    <Text
      icon={<IconMoney tone="secondary" data={{ testid: 'money-icon' }} />}
      size="small"
    >
      {displaySalaryFromSalaryType[type]}
    </Text>
  );
};
